<template>
  <div>
    <h2>Manuscript Reviews</h2>

    <v-card class="pa-2 mt-2">
      <v-text-field
        outlined
        hide-details
        v-model="search"
        label="Search communications"
        prepend-inner-icon="mdi-note-search"
      ></v-text-field>
    </v-card>

    <v-data-table
      :search="search"
      :headers="headers"
      :items="reviews"
      :items-per-page="10"
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        <small>{{ formatDate(item.createdAt) }}</small>
      </template>
      <template v-slot:[`item.manuscript.folder`]="{ item }">
        {{ `JMESR/${String(item.manuscript.folder).toUpperCase()}` }}
      </template>
      <template v-slot:[`item._id`]="{ item }">
        <v-btn
          small
          outlined
          color="green"
          class="my-1 mr-1"
          :to="`/editorial/complete/${item.manuscript._id}`"
        >
          Manuscript Details
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatDate } from "../../tools/format";

export default {
  data: () => ({
    search: "",
    loading: false,
    deleting: false,
    reviews: [],
    headers: [
      { text: "Written on", value: "createdAt" },
      { text: "Recommendation", value: "recommendation" },
      { text: "Manuscript ID", value: "manuscript.folder" },
      {
        text: "Manuscript Title",
        align: "start",
        value: "manuscript.title",
      },
      { text: "Actions", value: "_id", sortable: false },
    ],
  }),
  methods: {
    formatDate,
    fetchReviews() {
      this.loading = true;
      this.$axios
        .get("/editorial/reviews")
        .then(({ data: response }) => {
          this.reviews = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve reviews",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchReviews();
  },
};
</script>
